// Formik field names
export const ScheduleDateFieldName = "date";
export const ScheduleTimeFieldName = "time";
export const RRuleIntervalFieldName = "repeatInterval";
export const RRuleFrequencyFieldName = "repeatFrequency";
export const RRuleEndConditionFieldName = "rRuleEndRadio";
export const RRuleEndNever = "endRRuleNever";
export const RRuleEndOnDateFieldName = "endRRuleOnDate";
export const RRuleEndAfterCountFieldName = "endRRuleAfterCount";
